import React from 'react';
import SkeletonLoader from '../../../../components/Common/SkeletonLoader';

const StudentDetailsSkeletonLoader: React.FC = () => {
  return (
    <div className="row">
      {/* Skeleton for student info card */}
      <div className="col-md-4 mb-4">
        <div className="card skeleton-list-item">
          <div className="card-body">
            <div className="text-center mb-4">
              <SkeletonLoader type="circle" width="100px" height="100px" className="mx-auto mb-3" />
              <SkeletonLoader type="text" width="150px" height="24px" className="mx-auto mb-2" variant="large" />
              <SkeletonLoader type="text" width="100px" height="16px" className="mx-auto" variant="small" />
            </div>

            <div className="border-top pt-3">
              <div className="row text-center">
                {[1, 2, 3].map((i) => (
                  <div key={i} className="col-4" style={{ '--item-index': i } as React.CSSProperties}>
                    <SkeletonLoader type="text" width="30px" height="24px" className="mx-auto mb-1" variant="large" index={i} />
                    <SkeletonLoader type="text" width="60px" height="16px" className="mx-auto" variant="small" index={i} />
                  </div>
                ))}
              </div>
            </div>

            <div className="mt-4">
              <SkeletonLoader type="progress" width="100%" height="10px" className="mb-2" />
              <div className="d-flex justify-content-between small">
                <SkeletonLoader type="text" width="80px" height="16px" variant="small" />
                <SkeletonLoader type="text" width="80px" height="16px" variant="small" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Skeleton for absence history */}
      <div className="col-md-8">
        <div className="card skeleton-list-item">
          <div className="card-header">
            <SkeletonLoader type="text" width="150px" height="24px" variant="large" />
          </div>
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-hover table-center mb-0">
                <thead>
                  <tr>
                    {[1, 2, 3, 4].map((i) => (
                      <th key={i}>
                        <SkeletonLoader type="text" width="80px" height="20px" index={i} />
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {[1, 2, 3, 4, 5].map((i) => (
                    <tr key={i} style={{ '--item-index': i } as React.CSSProperties}>
                      {[1, 2, 3, 4].map((j) => (
                        <td key={j}>
                          <SkeletonLoader 
                            type={j === 4 ? 'badge' : 'text'} 
                            width={j === 4 ? '60px' : '80px'} 
                            height="20px" 
                            index={i} 
                          />
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentDetailsSkeletonLoader;
